import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { SellingCompanyCountry } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyCountryService extends TmsWebBaseEditCreateService<
  SellingCompanyCountry,
  SellingCompanyCountry
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SellingCompanyCountry', $localize`Selling Company Country`, httpService, notificationService);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyCountry[]> {
    return this.httpService.get<SellingCompanyCountry[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
